// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__Yp8nJ","cabecalho__container":"Cabecalho_cabecalho__container__j2Ht5","cabecalho__input":"Cabecalho_cabecalho__input__B01TF"};